/*
 * @Description:财务管理
 * @Author: lyy
 * @Date: 2022-07-21 19:46:54
 * @LastEditors: your Name
 * @LastEditTime: 2022-07-28 18:40:29
 */

import $axios from "@/utils/$axios";

const useApi = {
  getRetireExpensesUrl: "/retireExpenses/getRetireExpenses", // 查询退休费用
  retireExpensesSaveUrl: "/retireExpenses/retireExpensesSave", // 保存退休费用
  getFamilIncomeUrl: "/familyIncome/getFamilIncome", //查询已备费用
  familyIncomeSaveUrl: "familyIncome/familyIncomeSave", //保存已备费用
  getShouldPreparedFeeListUrl: "/shouldPreparedFee/getShouldPreparedFeeList", //获取应备费用表
  createUrl: '/shouldPreparedFee/create', //保存应备费用表
  getFinancialNeedsAnalysisDataUrl: '/analysis/getFinancialNeedsAnalysisData'//获取财务需求分析数据接口
};

// 退休费用
export function getRetireExpensesFn(data) {
  return $axios({
    url: useApi.getRetireExpensesUrl,
    method: "post",
    data
  });
}

// 保存退休费用
export function retireExpensesSaveFn(params) {
  return $axios({
    url: useApi.retireExpensesSaveUrl,
    method: "post",
    data: params
  });
}

export function familyIncomeSaveFn(params) {
  return $axios({
    url: useApi.familyIncomeSaveUrl,
    method: "post",
    data: params
  });
}
export function getFamilIncomeFn(params) {
  return $axios({
    url: useApi.getFamilIncomeUrl,
    method: "post",
    data: params
  });
}
export function getShouldPreparedFeeListFn(params) {
  return $axios({
    url: useApi.getShouldPreparedFeeListUrl,
    method: "get",
    params
  });
}
export function createFn(data) {
  return $axios({
    url: useApi.createUrl,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

export function getFinancialNeedsAnalysisDataFn(params) {
  return $axios({
    url: useApi.getFinancialNeedsAnalysisDataUrl,
    method: "get",
    params
  });
}